import { produce } from "immer";
import {
  CLEAR_DISCIPLINARY_MESSAGE,
  DELETE_DISCIPLINARY,
  DELETE_DISCIPLINARY_FAILURE,
  DELETE_DISCIPLINARY_SUCCESS,
  FETCH_DISCIPLINARY,
  FETCH_DISCIPLINARY_FAILURE,
  FETCH_LOCATION_DISCIPLINARY,
  FETCH_LOCATION_DISCIPLINARY_FAILURE,
  FETCH_LOCATION_DISCIPLINARY_SUCCESS,
  FETCH_DISCIPLINARY_RECORD,
  FETCH_DISCIPLINARY_RECORD_FAILURE,
  FETCH_DISCIPLINARY_RECORD_SUCCESS,
  FETCH_DISCIPLINARY_SUCCESS,
  POST_DISCIPLINARY_ACTION,
  POST_DISCIPLINARY_ACTION_FAILURE,
  POST_DISCIPLINARY_ACTION_SUCCESS,
  SAVE_DISCIPLINARY,
  SAVE_DISCIPLINARY_FAILURE,
  SAVE_DISCIPLINARY_SUCCESS,
  UPLOAD_DISCIPLINARY_ATTACHMENT,
  UPLOAD_DISCIPLINARY_ATTACHMENT_FAILURE,
  UPLOAD_DISCIPLINARY_ATTACHMENT_SUCCESS,
} from "./constants";

const initialState = {
  rows: [],
  record: null,
  isFetching: false,
  isSaving: false,
  message: "",
  locationList: {
    data: [],
    current_page: 1,
    last_page: 1,
    total: 0,
  },
  isFetchingLocation: false,
};

const DisciplinaryReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case FETCH_DISCIPLINARY:
        draft.isFetching = true;
        draft.message = "";
        break;
      case FETCH_DISCIPLINARY_SUCCESS:
        draft.isFetching = false;
        draft.rows = action.payload || [];
        break;
      case FETCH_DISCIPLINARY_FAILURE:
        draft.isFetching = false;
        draft.message = "";
        break;

      case FETCH_LOCATION_DISCIPLINARY:
        draft.isFetchingLocation = true;
        break;
      case FETCH_LOCATION_DISCIPLINARY_SUCCESS:
        draft.isFetchingLocation = false;
        draft.locationList = {
          data: action.payload?.data || [],
          current_page: action.payload?.current_page ?? 1,
          last_page: action.payload?.last_page ?? 1,
          total: action.payload?.total ?? 0,
        };
        break;
      case FETCH_LOCATION_DISCIPLINARY_FAILURE:
        draft.isFetchingLocation = false;
        draft.locationList = {
          data: [],
          current_page: 1,
          last_page: 1,
          total: 0,
        };
        break;

      case FETCH_DISCIPLINARY_RECORD:
        draft.isFetching = true;
        draft.message = "";
        break;
      case FETCH_DISCIPLINARY_RECORD_SUCCESS:
        draft.isFetching = false;
        draft.record = action.payload || null;
        break;
      case FETCH_DISCIPLINARY_RECORD_FAILURE:
        draft.isFetching = false;
        draft.message = "";
        break;

      case SAVE_DISCIPLINARY:
      case POST_DISCIPLINARY_ACTION:
      case UPLOAD_DISCIPLINARY_ATTACHMENT:
      case DELETE_DISCIPLINARY:
        draft.isSaving = true;
        draft.message = "";
        break;
      case SAVE_DISCIPLINARY_SUCCESS:
        draft.isSaving = false;
        draft.message = "Saved.";
        break;
      case POST_DISCIPLINARY_ACTION_SUCCESS:
        draft.isSaving = false;
        draft.record = action.payload || draft.record;
        draft.message = "Updated.";
        break;
      case UPLOAD_DISCIPLINARY_ATTACHMENT_SUCCESS:
        draft.isSaving = false;
        draft.message = "Document uploaded.";
        break;
      case DELETE_DISCIPLINARY_SUCCESS:
        draft.isSaving = false;
        draft.record = null;
        draft.message = "Draft deleted.";
        break;
      case SAVE_DISCIPLINARY_FAILURE:
      case POST_DISCIPLINARY_ACTION_FAILURE:
      case UPLOAD_DISCIPLINARY_ATTACHMENT_FAILURE:
      case DELETE_DISCIPLINARY_FAILURE:
        draft.isSaving = false;
        draft.message = "";
        break;

      case CLEAR_DISCIPLINARY_MESSAGE:
        draft.message = "";
        break;

      default:
        break;
    }
  });

export default DisciplinaryReducer;
